import { useCallback, useState } from "react";
import reset from "skin/entry/query/reset";
import { type } from 'skin/event'

export default function useReset() {
	const [wait, setWait] = useState(false);
	const [err, setErr] = useState(null);
	
	const [login, setLogin] = useState('');
	const [errLogin, setErrLogin] = useState(null);
	const onLoginChange = useCallback(ev => {
		const v = ev.target.value;
		setLogin(v);
		setErrLogin(null);
		setErr(null);
	}, []);
	
	const [email, setEmail] = useState('');
	const [errEmail, setErrEmail] = useState(null);
	const onEmailChange = useCallback(ev => {
		const v = ev.target.value;
		setEmail(v);
		setErrEmail(null);
		setErr(null);
	}, []);

	const log = { value: login, onChange: onLoginChange, err: errLogin };
	const em = { value: email, onChange: onEmailChange, err: errEmail };

	return { wait, err, log, em, submit };

	function submit() {
		const ok = validate();
		if (!ok) return;
		setWait(true);
		reset(login, email)
		.then(_ => {
			alert('Новый пароль отправлен на почту');
			type('login');
		})
		.catch(e => {
			setErr(e.toString())
		})
		.finally(() => setWait(false))
	}

	function validate() {
		let ok = true;
		const reg = /^[\w]*$/;
		const regEmail = /^[^@\s]+@[^@\s.]+\.[^@\s.]+$/;
		if (!login) {
			ok = false;
			setErrLogin(true);
		} else {
			if (!reg.test(login)) {
				ok = false;
				setErrLogin('Логин должен содержать только латинские символы и цифры');
			}
		}
		if (!email) {
			ok = false;
			setErrEmail(true);
		} else {
			if (!regEmail.test(email)) {
				ok = false;
				setErrEmail('Некорректный почтовый адрес');
			}
		}
		return ok;
	}
}